import { atom } from "recoil";

const plusSectionAtom = atom({
  key: "plusSectionState",
  default: false,
});

export default plusSectionAtom;
